.LinkHistoryItem {
  align-items: flex-start;
  background-color: var(--color-background--shaded);
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
  max-width: 37.5rem;

  pre {
    font-family: var(--font-mono);
    padding: 0 1.25rem;
    white-space: pre-wrap;
    word-break: break-all;

    & a.link {
      color: var(--color-text);

      &:hover {
        text-decoration-thickness: 1.5px;
      }
    }
  }

  .buttonWrapper {
    min-width: 5rem;
    padding-top: 0.6rem;
    text-align: right;
  }

  button {
    background: transparent;
    border-radius: 0.25rem;
    border: none;
    color: var(--color-accent);
    margin-right: 0.5rem;
    padding: 0.25rem 0.25rem 0;

    &:hover,
    &:active {
      background-color: var(--color-accent);
      color: var(--color-background--unshaded);
    }

    &:hover {
      outline: var(--focus-outline);
    }

    &:active {
      outline: var(--focus-outline--active);
    }
  }
}
